/* MIcase 2026-08-15 · Foto real por diseno en las lineas del carrito.

   DE DONDE VIENE: estaba en linea dentro de snippets/micase-modelo.liquid, o sea dentro
   del <head> de TODAS las paginas, repetido en cada HTML. Sale a un asset con defer para
   que se cachee entre paginas, que es la regla de ligereza del proyecto.

   POR QUE ES SEGURO MOVERLO: no pinta nada del primer pintado. Solo cambia el src de las
   miniaturas de hidrogel dentro del carrito, y ya esperaba a DOMContentLoaded por su
   cuenta; con defer arranca en ese mismo momento. Nadie mas lo llama: la bandera
   window.__mcDisFotoOn solo aparece en este archivo.
*/
(function(){
  if (window.__mcDisFotoOn) { return; }
  window.__mcDisFotoOn = 1;

  var CDN = 'https://cdn.shopify.com/s/files/1/0417/3922/3189/files/';
  var MAPA = {
    'carbono negro': 'HidrogelTrasero_11',
    'galaxia negro': 'HidrogelTrasero_13',
    'galaxia azul': 'HidrogelTrasero_2',
    'galaxia violeta': 'HidrogelTrasero_8',
    'tornasol': 'HidrogelTrasero_4',
    'tornasol oscuro': 'HidrogelTrasero_5',
    'white rose gold': 'HidrogelTrasero_7',
    'snake leather': 'HidrogelTrasero_9',
    'asimetric leather': 'HidrogelTrasero_10'
  };
  var RX = /dise[nñ]o\s*:\s*([^\n\r|·•]{3,40})/i;
  var SEL = 'dd,dt,p,span,small,li,td,div';

  function limpia(s){
    return String(s == null ? '' : s).toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function aplica(){
    var nodos = document.querySelectorAll(SEL);
    for (var i = 0; i < nodos.length; i++) {
      var el = nodos[i];
      if (el.children.length > 3) { continue; }
      var m = (el.textContent || '').match(RX);
      if (!m) { continue; }
      var archivo = MAPA[limpia(m[1])];
      if (!archivo) { continue; }

      // se sube hasta 8 niveles buscando la foto de ESA linea del carrito
      var p = el, img = null, n = 0;
      while (p && n++ < 8) {
        img = p.querySelector('img');
        if (img) { break; }
        p = p.parentElement;
      }
      if (!img) { continue; }

      var src = (img.currentSrc || img.getAttribute('src') || '').toLowerCase();
      if (src.indexOf('hidrogel') < 0) { continue; }
      if (img.getAttribute('data-mcdis-foto') === archivo) { continue; }

      img.setAttribute('data-mcdis-foto', archivo);
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', CDN + archivo + '.jpg?width=300');
    }
  }

  var t = null;
  function pide(){
    if (t) { clearTimeout(t); }
    t = setTimeout(aplica, 120);
  }

  function arranca(){
    aplica();
    if (window.MutationObserver) {
      new MutationObserver(pide).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('micase:carrito', pide);
    window.addEventListener('pageshow', pide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
